import styled from "styled-components"

const StyledArrowWrapper = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.boxBackground};
  position: relative;
  margin-bottom: 1rem;
`

const arrowY = `clamp(3rem, 2.4rem + 3vw, 6rem)`
const StyledArrow = styled.div`
  width: 0;
  height: 0;
  border-left: ${arrowY} solid transparent;
  border-right: ${arrowY} solid transparent;
  border-top: clamp(1rem, 0.8rem + 1vw, 2rem) solid
    ${(props) => props.theme.colors.bodyBackground};

  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
`

const EstimatesArrow = () => {
  return (
    <StyledArrowWrapper>
      <StyledArrow />
    </StyledArrowWrapper>
  )
}

export { EstimatesArrow }
